import { render, staticRenderFns } from "./ButtonVerticalDots.vue?vue&type=template&id=987fcb4a&scoped=true"
import script from "./ButtonVerticalDots.vue?vue&type=script&lang=ts"
export * from "./ButtonVerticalDots.vue?vue&type=script&lang=ts"
import style0 from "./ButtonVerticalDots.vue?vue&type=style&index=0&id=987fcb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987fcb4a",
  null
  
)

export default component.exports